import { Avatar, Box, Checkbox, IconButton, List, ListItem, ListItemAvatar, ListItemText, Tooltip } from '@mui/material';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Notification } from '../../../../../interfaces/Commons/Notifications/notifications';
import CircleIcon from '@mui/icons-material/Circle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ImageIcon from '@mui/icons-material/Image';
import { useNotificationDetailsStore } from '../../../../../store/Notifications/NotificationDetailsStore';
import { NotificationDetail } from '../../../../../interfaces/Commons/Notifications/notificationDetails';

interface NotificationListProps {
    filteredNotifications: Notification[],
    selectedNotifications: Notification[],
    handleSelectNotification: (notification: Notification) => void,
    handleMarkAsRead: (notification: Notification) => void,
    handleDeleteNotification: (notification: Notification) => void,
    loadingPost: boolean,
    showSelectAllIcon: boolean,
}

export const NotificationList = ({
    filteredNotifications,
    selectedNotifications,
    handleSelectNotification,
    handleMarkAsRead,
    handleDeleteNotification,
    loadingPost,
    showSelectAllIcon,
}: NotificationListProps) => {

    const [t] = useTranslation("global");

    const [hoveredNotificationId, setHoveredNotificationId] = useState<number | null>(null);
    const [expandedNotificationId, setExpandedNotificationId] = useState<number | null>(null);
    const notificationDetails = useNotificationDetailsStore(store=> store.notificationDetails);
    
    

    return (
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {filteredNotifications.length > 0 ? (
                filteredNotifications.map((notification, index) => {
                    const isRead = notification.notification_status_id === 2;
                    const isDeleted = notification.notification_status_id === 3;
                    const isSelected = selectedNotifications.some(n => n.notification_id === notification.notification_id);
                    const notificationDetail= notificationDetails.find(
                        (notificationDetail: NotificationDetail)=> notificationDetail.notification_id==notification.notification_id);
                    return (
                        <ListItem
                            key={index}
                            sx={{
                                backgroundColor: isSelected ? '#F4F9FD' : 'white',
                                cursor: 'pointer',
                                paddingRight: '16px',
                                width: '420px'
                            }}
                            onMouseEnter={() => {if(notification.notification_id ) setHoveredNotificationId(notification.notification_id)}}
                            onMouseLeave={() => setHoveredNotificationId(null)}
                            secondaryAction={
                                <Box sx={{ display: 'flex', gap: .5, justifyContent: 'flex-end' }}>
                                    <Tooltip title={isRead ? t("generic.notifications.actions.mark-as-unread") : t("generic.notifications.actions.mark-as-read")} placement='top'>
                                        <span>
                                            <IconButton
                                                onClick={() => handleMarkAsRead(notification)}
                                                disabled={loadingPost || isDeleted}
                                            >
                                                <CircleIcon color={isRead || isDeleted ? "disabled" : "primary"} />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    {!isDeleted && (
                                        <Tooltip title={t("generic.notifications.actions.mark-as-deleted")} placement='top'>
                                            <span>
                                                <IconButton aria-label="delete" disabled={loadingPost} onClick={() => handleDeleteNotification(notification)}>
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    )}
                                    <Tooltip title={t("generic.notifications.actions.open-section")} placement='top'>
                                        <IconButton edge="end" onClick={()=> window.open(`${notificationDetail?.resource_route}`, '_blank')}>
                                            <OpenInNewIcon />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            }
                        >
                            <ListItemAvatar>
                                {selectedNotifications.length > 0 || hoveredNotificationId === notification.notification_id || showSelectAllIcon ? (
                                    <Checkbox
                                        checked={isSelected}
                                        tabIndex={-1}
                                        onChange={() => handleSelectNotification(notification)}
                                        checkedIcon={<CheckBoxIcon />}
                                    />
                                ) : (
                                    <Avatar>
                                        <ImageIcon />
                                    </Avatar>
                                )}
                            </ListItemAvatar>
                            <ListItemText
                                onClick={() => {
                                    if (expandedNotificationId === notification.notification_id) {
                                        setExpandedNotificationId(null);
                                    } else {
                                        if(notification.notification_id) setExpandedNotificationId(notification.notification_id);
                                    }
                                }}
                                primary={
                                    <Box
                                        sx={{
                                            whiteSpace: expandedNotificationId === notification.notification_id ? 'normal' : 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            width: '200px'
                                        }}
                                    >
                                        {notification.notification_name}
                                    </Box>
                                }
                                secondary={
                                    <Box
                                        sx={{
                                            whiteSpace: expandedNotificationId === notification.notification_id ? 'normal' : 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            width: '200px'
                                        }}
                                    >
                                        {notification.notification_description}
                                    </Box>
                                }
                            />
                        </ListItem>
                    );
                })
            ) : (
                <ListItem >
                    <ListItemText sx={{ textAlign: 'center' }} primary={t("generic.notifications.no-notifications")} />
                </ListItem>
            )}
        </List>
    );
};
